/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Practice } from './practice';


/**
 * Serializer for the AppointmentType model.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface AppointmentType { 
    readonly id: number;
    name: string;
    lengthInMin: number;
    readonly practice: Practice;
}
export const AppointmentType_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentType_name_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(127),];

export const AppointmentType_lengthInMin_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.min(-2147483648), Validators.max(2147483647),];

export const AppointmentType_practice_Validators: ValidatorFn[] =
    [  Validators.required, ];


